import React from 'react'
import ENLayout from '../../components/Default/ENLayout'
import { H2Blue, UnderlineYellow } from '../../components/Typography'
import './styles.css'
import {
  Position,
  Name,
  WrapRow,
} from '../../components/Homepage/OurTeam/styled'
import { ResponsiveImage } from '../../components/ResponsiveImage'
import { Link } from '@reach/router'

import { graphql, useStaticQuery } from 'gatsby'
import './../../components/Homepage/LandingPhoto/styles.css'
import dane from './../../../static/images/dane.png'
import firemniporadenstvi from './../../../static/images/firemniPoradenstvi.png'
import mzdy from './../../../static/images/mzdy.png'
import ucetnictvi from './../../../static/images/ucetnictvi.png'
import Img from 'gatsby-image'
const EN = ({ photo }) => {
  return (
    <ENLayout
      meta={{ title: 'EK Partners', description: 'Here will be description' }}
    >
      <div className="LandingPhoto">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-12"
            style={{ backgroundColor: '#e2e1dd' }}
          >
            <Img fluid={photo.fluid} alt="Homepage photo" />
          </div>
          <div className="col-xl-5 offset-xl-1 col-lg-12">
            <div className="container row justify-content-center">
              <div className="h1-mobile col-12">
                <h1>EK Partners, s.r.o.</h1>
                <h2>tax advisors and accountants</h2>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/en/services/#taxes">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
                    <img src={dane} alt="Daně" />
                    <h2>Taxes</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/en/services/#accounting">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
                    <img src={ucetnictvi} alt="Účetnictví" />
                    <h2>Accounting</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/en/services/#transactions">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
                    <img src={firemniporadenstvi} alt="Firemní poradenství" />
                    <h2> Transactions</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/en/services/#consulting">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
                    <img src={mzdy} alt="Mzdy" />
                    <h2>Consuluing</h2>
                  </div>
                </Link>
              </div>
              <div className="h1-desktop col-12">
                <h2 className="h2-mobile">EK Partners, s.r.o.</h2>
                <h2 id="about-us">tax advisors and accountants</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Paragraph--Wrapper container">
        <H2Blue>ABOUT US</H2Blue>
        <UnderlineYellow />
        <p style={{ marginTop: '5.8rem' }}>
          We help our clients within the area of taxes and accounting. We are
          professionals with the years of working experience in successful
          consulting companies.
        </p>
        <p id="team">
          Primarily, we focus on the tax system in the Czech Republic,
          transactions connected with transferring assets and other items,
          company consulting, accounting systems and payroll accounting.
          Furthermore, we provide expert opinions on tax and accounting
          problems. Our work ethic is to be the most efficient so that our
          clients can fully focus on their business and its development.
        </p>
        <div>
          <H2Blue>Our team</H2Blue>
          <UnderlineYellow />
          <WrapRow>
            <div className="row align-items-center">
              <div className="col-lg-12 blue-line-two"></div>
              <div className="col-md-6">
                <ResponsiveImage
                  className="img-transform-scale"
                  src={`/images/team/lukas_eisenwort.jpg`}
                  alt="lukas-eisenwort"
                  width="252"
                />
                <Name>Lukáš Eisenwort</Name>
                <Position>Partner, tax consultant</Position>
              </div>
              <div className="col-md-6">
                <ResponsiveImage
                  className="img-transform-scale"
                  src={`/images/team/jan_kotala.jpg`}
                  alt="jan-kotala"
                  width="252"
                />
                <Name>Jan Kotala</Name>
                <Position>Partner, tax consultant</Position>
              </div>
            </div>
          </WrapRow>
        </div>
      </div>
    </ENLayout>
  )
}

const ENData = () => {
  const { homepageLanding } = useStaticQuery(graphql`
    query {
      homepageLanding: file(relativePath: { eq: "homepage-landing.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <EN photo={homepageLanding.childImageSharp} />
}

export default ENData
